export default __webpack_public_path__ + "static/squeezing-ce0111dbd601010ebf61790cdd2348ab.svg";